import {
	Button,
	Flex,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
} from "@chakra-ui/react"
import { FC, useRef } from "react"
import { BsPrinterFill } from "react-icons/bs"
import ReactToPrint from "react-to-print"
import { IHallBooking, IHallBookingBill } from "src/domain/entities"
import { VaadiRentBillPrintView } from "../ReceiptPrintsPage"

interface Props {
	hallBookingBill: IHallBookingBill
	hallBooking: IHallBooking
	isOpen: boolean
	setIsOpen: (isOpen: boolean) => void
}

export const HallBookingBillPreviewDialogController: FC<Props> = ({
	isOpen,
	setIsOpen,
	hallBookingBill,
	hallBooking,
}) => {
	const onClose = () => setIsOpen(false)

	const printComponentRef = useRef<HTMLDivElement>(null)

	return (
		<>
			<Modal onClose={onClose} isOpen={isOpen} isCentered size={"3xl"}>
				<ModalOverlay />
				<ModalContent>
					<ModalHeader>Hall Booking Bill Preview</ModalHeader>
					<ModalCloseButton />
					<ModalBody>
						<VaadiRentBillPrintView
							hallBookingBill={hallBookingBill}
							hallBooking={hallBooking}
						/>
					</ModalBody>
					<ModalFooter>
						<Flex gridColumnGap={2}>
							<Button onClick={onClose}>Close</Button>
							<div ref={printComponentRef} className="printable">
								<VaadiRentBillPrintView
									hallBookingBill={hallBookingBill}
									hallBooking={hallBooking}
								/>
							</div>
							<ReactToPrint
								content={() => printComponentRef.current}
								copyStyles={true}
								trigger={() => (
									<Button
										colorScheme={"green"}
										leftIcon={<BsPrinterFill />}
									>
										Print
									</Button>
								)}
							/>
						</Flex>
					</ModalFooter>
				</ModalContent>
			</Modal>
		</>
	)
}
